import { ReactNode } from "react"
import {
  EditButton,
  STable,
  Th,
  Tr,
  TableHeader,
  StyledTable,
  StyledTr,
  StyledTd,
  TextValue,
  TextName,
} from "./SummaryTable.styled"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"
import { Subheader } from "../components/Subheader"

type Props = {
  header: string
  borderlessHeader?: boolean
  headerBorderRight?: boolean
  onEditClick?: () => void
  children: ReactNode
}

export function SummaryTable(props: Props) {
  const { header, borderlessHeader, headerBorderRight, onEditClick, children } = props
  return (
    <STable>
      <thead>
        <Tr borderless={borderlessHeader}>
          <Th placement="inHeader" borderRight={headerBorderRight}>
            {header} {onEditClick && <EditButton onClick={onEditClick} />}
          </Th>
        </Tr>
      </thead>
      <tbody>{children}</tbody>
    </STable>
  )
}

interface DataType {
  name: string
  value: ReactNode
}

interface DynamicTableProps {
  data: DataType[]
  header?: string
  onEditClick?: () => void
}

export const DynamicTable = (props: DynamicTableProps) => {
  const { data, header, onEditClick } = props
  const rows = []
  for (let i = 0; i < data.length; i += 2) {
    rows.push([data[i], data[i + 1]])
  }

  return (
    <>
      <TableHeader>
        {header && <Subheader asSectionHeader>{header}</Subheader>}
        {onEditClick && <EditButton onClick={onEditClick} />}
      </TableHeader>
      <Spacer size={theme.space.s5_5} />
      <StyledTable>
        <tbody>
          {rows.map((row, i) => (
            <StyledTr key={i}>
              {row.map((col) =>
                col ? (
                  <StyledTd key={col.name}>
                    <TextName>{col.name}</TextName>
                    <TextValue>{col.value}</TextValue>
                  </StyledTd>
                ) : null
              )}
            </StyledTr>
          ))}
        </tbody>
      </StyledTable>
    </>
  )
}

export class DynamicTableDataBuilder {
  #data: DataType[] = []

  addData(...data: DataType[]) {
    for (const d of data) {
      this.#data.push(d)
    }
  }

  build() {
    return [...this.#data]
  }
}
